<template>
  <div v-if="loading">
    <MoonLoader class="loading"></MoonLoader>
  </div>

  <div v-else>
    <card-summary v-if="summaryCopy" :title="summaryCopy.category.name">
      <div class="row" slot="title">
        <div class="col-lg-6 text-left">
          <div class="flex">
            <span class="uppercase mr-3">
              {{ getCategoryName(summaryCopy.category.name) }}
            </span>
            <button
              v-tooltip="{
                content: 'Info about ' + summaryCopy.category.name + ' category',
                placement: 'bottom-center',
                classes: ['info'],
              }"
              class="cardCustom__header-info__item"
            >
              <i class="fas fa-info-circle" />
            </button>
          </div>
        </div>
        <div class="col-lg-6 text-right">
          <button
            v-tooltip="{
              content: 'Total Score ' + summaryCopy.score + '%',
              placement: 'bottom-center',
              classes: [getEmojiClass(summaryCopy)],
            }"
            :class="getEmojiClass(summaryCopy)"
          >
            <span class="" v-html="getStarts(summaryCopy)"></span>
          </button>
        </div>
      </div>
      <div class="row" slot="header">
        <div class="col flex justify-content-center -mt-14">
          <img class="cardCustom__icon" :src="summaryCopy.category.icon_url" alt="" />
        </div>
      </div>
      <div class="row justify-content-between" slot="content">
        <div class="col-md-2">
          <div class="cardCustom__content__point cardCustom__content__point--green">
            <button
              v-tooltip="{
                content: 'Done',
                placement: 'bottom-center',
                classes: ['success'],
              }"
              class="cardCustom__content__point__value"
            >
              {{ summaryCopy.green }}
            </button>
          </div>
        </div>
        <div class="col-md-2">
          <div class="cardCustom__content__point cardCustom__content__point--yellow">
            <button
              v-tooltip="{
                content: 'In Progress',
                placement: 'bottom-center',
                classes: ['warning'],
              }"
              class="cardCustom__content__point__value"
              @click="moveToElements('In Progress')"
            >
              {{ summaryCopy.yellow }}
            </button>
          </div>
        </div>
        <div class="col-md-2">
          <div class="cardCustom__content__point cardCustom__content__point--red">
            <button
              v-tooltip="{
                content: 'Open',
                placement: 'bottom-center',
                classes: ['danger'],
              }"
              class="cardCustom__content__point__value"
              @click="moveToElements('Open')"
            >
              {{ summaryCopy.red }}
            </button>
          </div>
        </div>
        <div class="col-md-2">
          <div class="cardCustom__content__point cardCustom__content__point--disabled">
            <button
              v-tooltip="{
                content: 'Not answered',
                placement: 'bottom-center',
                classes: ['disabled'],
              }"
              class="cardCustom__content__point__value"
              @click="moveToElements('Not Answered')"
            >
              {{ summaryCopy.grey }}
            </button>
          </div>
        </div>
      </div>
    </card-summary>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import CardSummary from '@/components/Cards/CardSummary';
import DefineValueClass from '@/controllers/Class/DefineValueClass';
import QuestionTypeController from '@/controllers/QuestionType/QuestionTypeController';

export default {
  name: 'DashboardElementSummary',
  components: { CardSummary, MoonLoader },
  props: {
    summary: Object,
  },
  data() {
    return {
      loading: false,
      summaryCopy: null,
      categoryCopy: null,
      questionType: null,
    };
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
  },
  async mounted() {
    this.loading = true;
    await this.setSummary(this.summary);
    this.loading = false;
    this.questionType = await this.getQuestionType();
  },
  methods: {
    setSummary(summary) {
      this.summaryCopy = summary;
    },
    getCategoryName(name) {
      if (name.toLowerCase() === 'education and policies') name = 'policies';
      if (name.toLowerCase() === 'membershipengagement') name = 'membership';
      return name;
    },
    getStarts(summary) {
      return DefineValueClass.defineStars(summary.score);
    },
    getSummaryEmoji(summary) {
      return DefineValueClass.defineEmoji(summary.score);
    },
    getEmojiClass(summary) {
      return DefineValueClass.defineClass(summary.score);
    },
    moveToElements(sortBy) {
      let category = this.summaryCopy.category;
      this.$router.push({
        path: '/manage_answers/' + this.company.company_id,
        query: {
          company: this.company,
          selectedQuestionType: this.questionType,
          selectedFilters: [category, sortBy],
        },
      });
    },
    async getQuestionType() {
      let questionTypes = await QuestionTypeController.index();
      let vm = this;
      return questionTypes.find(function (questionType) {
        return questionType.id === vm.summaryCopy.question_type.id;
      });
    },
  },
};
</script>

<style scoped></style>
